export const ISSUE_TYPES = [
    'Rights issue',
    'ABB Directed issue',
    'Directed issue',
    'Non-cash issue',
    'Guarantor fee issue',
    'IPO',
] as const

export type IssueType = (typeof ISSUE_TYPES)[number]
